import { getIn } from 'seamless-immutable';
import { getTestABList, getTestAB } from '@catalogo/core-experiments';
import oneDayDeliveryQuery from '@catalogo/core-graphql-cache/src/local/one-day-delivery/one-day-delivery.graphql';
import xTidQuery from '@catalogo/core-x-tid/src/x-tid.graphql';
import getHeaders from '@catalogo/core-graphql-cache/src/local/headers/headers.graphql';
import getSegments from '@catalogo/core-segments/src/query.graphql';

export const getQs = req => {
  try {
    const qs = req ? getIn(req, ['_parsedUrl', 'query']) : window.location.search.substring(1);
    return qs || '';
  } catch (e) {
    return '';
  }
};

export const getPath = req => {
  try {
    const path = req ? getIn(req, ['_parsedUrl', 'pathname']) : window.location.pathname;
    return path || '';
  } catch (e) {
    return '';
  }
};

export const appendTestABHeaders = (headers, cache, req) => {
  const experiments = getTestABList(cache);

  const location = {
    search: getQs(req),
  };

  experiments.map(({ name }) => {
    headers[name] = getTestAB({ name, client: cache, location });
  });

  return headers;
};

export const appendOneDayDeliveryFiltered = (headers, cache) => {
  const { oneDayDeliveryFiltered } = cache.readQuery({
    query: oneDayDeliveryQuery,
  });

  headers.oneDayDeliveryFiltered = oneDayDeliveryFiltered;

  return headers;
};

export const appendXTid = (headers, cache) => {
  const data = cache.readQuery({
    query: xTidQuery,
  });

  headers['x-tid'] = data?.xTid;

  return headers;
};

export const appendAkamaiBot = (headers, cache) => {
  const headersQuery = cache.readQuery({ query: getHeaders });

  headers['akamai-bot'] = headersQuery?.headers?.['akamai-bot'];

  return headers;
};

export const appendSegments = (headers, cache, cookies) => {
  const data = cache.readQuery({
    query: getSegments,
    variables: {
      customerId: cookies['customer.id'] || '',
    },
  });

  headers['segments'] = data?.segments?.segments;

  return headers;
};

export const appendB2BHeaders = (headers, config, cookies) => {
  const isPortal = config.brand === 'portal';
  const isB2B = ['portal', 'aemp'].includes(config.brand);

  if (isPortal) {
    headers['portal'] = true;
  }

  if (isB2B) {
    headers['consumption-type'] = cookies?.consumptionType;
    headers['sales-solution'] = 'B2WEMPRESAS';
    headers['business'] = 'b2b';
  }

  return headers;
};

export const appendSalesSolutionHeader = (headers, cookies) => {
  const { salesSolution } = cookies ?? {};

  if (salesSolution?.toLowerCase() === 'qlas') {
    headers['sales-solution'] = salesSolution;
  }

  return headers;
};
